import { render, staticRenderFns } from "./CpWhiteList.vue?vue&type=template&id=0b9502d3&"
import script from "./CpWhiteList.vue?vue&type=script&lang=js&"
export * from "./CpWhiteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports